import { render, staticRenderFns } from "./screenTrivia.vue?vue&type=template&id=b431a530&"
import script from "./screenTrivia.vue?vue&type=script&lang=js&"
export * from "./screenTrivia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports